import { MetricConverter } from './helpers';

const TimeUnits = ['ns', 'us', 'ms', 's', 'min', 'h'] as const;
export type TTimeUnit = (typeof TimeUnits)[number];

class TimeConverter extends MetricConverter<TTimeUnit, 's'> {
    baseUnit = 's' as const;
    units = TimeUnits;

    getMultiplier(unit: TTimeUnit) {
        switch (unit) {
            case 'ns':
                return 1e-9;
            case 'us':
                return 1e-6;
            case 'ms':
                return 1e-3;
            case 's':
                return 1;
            case 'min':
                return 60;
            case 'h':
                return 3600;
        }
    }
}

export const timeConverter = new TimeConverter();
